import React, { Component, Fragment } from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import PageTransition from 'gatsby-plugin-page-transitions'
import { getPageContents } from '../components/api'
import Slider from 'react-slick'
import Slide from '../components/slide'

import Responsive from 'react-responsive'

const Mobile = props => <Responsive {...props} maxWidth={767} />
const Desktop = props => <Responsive {...props} minWidth={992} />

const Wrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 100vw;
`

const NavigationDimmer = styled.div`
  position: fixed;
  top: 0;
  z-index: 1;
  width: 100vw;
  height: 15vw;
  background: linear-gradient(
    rgba(0, 0, 0, 0.7),
    rgba(0, 0, 0, 0.3),
    rgba(0, 0, 0, 0)
  );

  @media (max-width: 767px) {
    top: 0;
    height: 30vh;
    background: linear-gradient(
      rgba(0, 0, 0, 0.4),
      rgba(0, 0, 0, 0.3),
      rgba(0, 0, 0, 0)
    );
  }
`
const HeroDimmer = styled.div`
  position: absolute;
  left: 0;
  top: 60vh;
  width: 100vw;
  height: 20vh;
  background: linear-gradient(
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.2),
    rgba(0, 0, 0, 0.4)
  );
  z-index: 1;
  @media (max-width: 767px) {
    height: 19vh;
    top: 21vh;
    background: linear-gradient(
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0.4)
    );
    // background-color: red;
  }
`
const Image = styled.div`
  width: 100vw;
  height: 80vh;
  background-position: no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  @media (max-width: 767px) {
    height: 40vh;
  }
`
const ContentWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background-color: white;
`
const ContentBlock = styled.div`
  padding: 5vw;
  color: gray;
  background-color: white;
  -webkit-columns: 2 200px;
  -moz-columns: 2 200px;
  columns: 2 200px;
  -webkit-column-gap: 4em;
  -moz-column-gap: 4em;
  column-gap: 4em;

  > h2 {
    font-size: 1.5vw;
    font-family: OpensansSemiboldItalic;
    font-style: italic;
    line-height: 1.6;
  }

  > em {
    display: block;
    font-family: OpensansRegular;
    font-style: normal;
    margin-top: 2.5vw;
    // margin-bottom: 290px;
    text-transform: uppercase;
    font-size: 1vw;
  }

  > p {
    column-break-before: always;
    font-family: OpensansRegular;
    font-size: 1vw;
    line-height: 2;
    margin-top: 0.3vw;
  }

}
`
const ContentBlockMobile = styled.div`
  padding: 7vw;
  color: gray;
  background-color: white;

  > h2 {
    font-size: 3.5vw;
    font-family: OpensansSemiboldItalic;
    font-style: italic;
    line-height: 1.6;
  }

  > em {
    display: block;
    font-family: OpensansRegular;
    font-style: normal;
    margin-top: -2vw;
    text-transform: uppercase;
    font-size: 2vw;
  }

  > p {
    column-break-before: always;
    font-family: OpensansRegular;
    font-size: 3vw;
    line-height: 2;
    margin-top: 7vw;
  }

}
`
const Title = styled.div`
  position: absolute;
  top: 70vh;
  left: 7.5vw;
  font-family: OpensansItalic;
  font-size: 2vw;
  color: white;
  z-index: 1;
  @media (max-width: 767px) {
    top: 32vh;
    height: 19vh;
    left: 7.5vw;
    font-size: 5vw;
  }
`

const settings = {
  dots: false,
  arrows: false,
  fade: true,
  infinite: true,
  speed: 500,
  autoplay: true,
  lazyLoad: false,
  swipe: false,
  slidesToShow: 1,
  slidesToScroll: 1,
}

const SlideShow = styled(Slider)`
  width: 100vw;
  height: 80vh;
  @media (max-width: 767px) {
    height: 40vh;
  }
`
class Memory extends Component {
  state = {
    page: { slides_1: [], slides_2: [] },
    isLoading: true,
    lang: '',
  }

  componentDidMount() {
    this.setState({ isLoading: true })
    const lang = window.location.search
    getPageContents('/memoria', lang).then(page => {
      this.setState({ page: page, isLoading: false, lang })
    })
  }

  render() {
    const { slides_1, slides_2, bio_text_1, bio_text_2 } = this.state.page
    return (
      <PageTransition>
        <NavigationDimmer />
        <Wrapper>
          {!this.state.isLoading && (
            <Fragment>
              <HeroDimmer />
              <Title>
                {this.state.lang === '?lang=en' ? 'Memory' : `Memória`}
              </Title>
              <SlideShow {...settings}>
                {slides_1.map((slide, index) => {
                  return (
                    <div key={index}>
                      <Image
                        style={{
                          backgroundImage: `url(${slide})`,
                        }}
                      />
                    </div>
                  )
                })}
              </SlideShow>
              <ContentWrapper>
                <Desktop>
                  <ContentBlock
                    dangerouslySetInnerHTML={{ __html: bio_text_1 }}
                  />
                </Desktop>
                <Mobile>
                  <ContentBlockMobile
                    dangerouslySetInnerHTML={{ __html: bio_text_1 }}
                  />
                </Mobile>
                <SlideShow {...settings}>
                  {slides_2.map((slide, index) => {
                    return (
                      <div key={index}>
                        <Image
                          style={{
                            backgroundImage: `url(${slide})`,
                          }}
                        />
                      </div>
                    )
                  })}
                </SlideShow>
                <Desktop>
                  <ContentBlock
                    dangerouslySetInnerHTML={{ __html: bio_text_2 }}
                  />
                </Desktop>
                <Mobile>
                  <ContentBlockMobile
                    dangerouslySetInnerHTML={{ __html: bio_text_2 }}
                  />
                </Mobile>
              </ContentWrapper>
            </Fragment>
          )}
        </Wrapper>
      </PageTransition>
    )
  }
}

export default Memory



// WEBPACK FOOTER //
// ./src/pages/memoria.js